import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';

const renderLink = (overridelink, content, extraProps) => (
  <>
    <Link
      to={overridelink}
      {...extraProps}
      dangerouslySetInnerHTML={{ __html: unescape(content) }}
    />
  </>
);

const renderData = (wrapInPara, overridelink, content, extraProps) => {
  if (wrapInPara && overridelink) {
    return <p>{renderLink(overridelink, content, extraProps)}</p>;
  } else if (overridelink) {
    return (
      <React.Fragment>
        {renderLink(overridelink, content, extraProps)}
      </React.Fragment>
    );
  } else if (wrapInPara) {
    // eslint-disable-next-line react/no-danger
    return (
      <p
        className="liveblogtextlist"
        dangerouslySetInnerHTML={{ __html: unescape(content) }}
      />
    );
  }
  return (
    <p
      className="liveblogtextlist"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

const Text = props => {
  const { overridelink, content, wrapInPara,...extraProps } = props;
  if (typeof content !== 'string') {
    return null;
  }
  return <>{renderData(wrapInPara, overridelink, content, extraProps)}</>;
};

Text.propTypes = {
  overridelink: PropTypes.number,
  content: PropTypes.string.isRequired,
  wrapInPara: PropTypes.bool,
  
};

Text.defaultProps = {
  overridelink: undefined,
  wrapInPara: true,
};

export default Text;
